// extracted by mini-css-extract-plugin
export default {"objectDetailsInfo":"ArtObjectDetailsInfo_objectDetailsInfo__QixoU"};